import React, { useState } from 'react';
import { Link } from 'react-scroll';
import { FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <nav className="bg-gray-800 p-4 sticky top-0 z-50">
            <div className="container mx-auto flex justify-between items-center">
                <Link
                    to="home"
                    smooth={true}
                    duration={500}
                    className="text-xl font-bold text-blue-400 cursor-pointer"
                >
                    Monjul Boruah
                </Link>
                <div className="hidden md:flex space-x-6">
                    <Link
                        to="about"
                        smooth={true}
                        duration={500}
                        spy={true}
                        activeClass="text-blue-400"
                        className="hover:text-blue-400 transition cursor-pointer"
                    >
                        About
                    </Link>
                    <Link
                        to="experience"
                        smooth={true}
                        duration={500}
                        spy={true}
                        activeClass="text-blue-400"
                        className="hover:text-blue-400 transition cursor-pointer"
                    >
                        Experience
                    </Link>
                    <Link
                        to="skills"
                        smooth={true}
                        duration={500}
                        spy={true}
                        activeClass="text-blue-400"
                        className="hover:text-blue-400 transition cursor-pointer"
                    >
                        Skills
                    </Link>
                    <Link
                        to="projects"
                        smooth={true}
                        duration={500}
                        spy={true}
                        activeClass="text-blue-400"
                        className="hover:text-blue-400 transition cursor-pointer"
                    >
                        Projects
                    </Link>
                    <Link
                        to="contact"
                        smooth={true}
                        duration={500}
                        spy={true}
                        activeClass="text-blue-400"
                        className="hover:text-blue-400 transition cursor-pointer"
                    >
                        Contact
                    </Link>
                </div>

                <button
                    className="md:hidden text-gray-300 focus:outline-none"
                    onClick={toggleMenu}
                    aria-label="Toggle menu"
                >
                    {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
                </button>
            </div>
            {/* Mobile Navigation */}
            {isOpen && (
                <div className="md:hidden bg-gray-700 px-4 py-2 mt-2 rounded-lg">
                    <div className="flex flex-col space-y-3">
                        <Link
                            to="about"
                            smooth={true}
                            duration={500}
                            className="hover:text-blue-400 transition cursor-pointer py-2"
                            onClick={toggleMenu}
                        >
                            About
                        </Link>
                        <Link
                            to="experience"
                            smooth={true}
                            duration={500}
                            className="hover:text-blue-400 transition cursor-pointer py-2"
                            onClick={toggleMenu}
                        >
                            Experience
                        </Link>
                        <Link
                            to="skills"
                            smooth={true}
                            duration={500}
                            className="hover:text-blue-400 transition cursor-pointer py-2"
                            onClick={toggleMenu}
                        >
                            Skills
                        </Link>
                        <Link
                            to="projects"
                            smooth={true}
                            duration={500}
                            className="hover:text-blue-400 transition cursor-pointer py-2"
                            onClick={toggleMenu}
                        >
                            Projects
                        </Link>
                        <Link
                            to="contact"
                            smooth={true}
                            duration={500}
                            className="hover:text-blue-400 transition cursor-pointer py-2"
                            onClick={toggleMenu}
                        >
                            Contact
                        </Link>
                    </div>
                </div>
            )}
        </nav>
    );
};

export default Navbar;